import React, { useEffect, useMemo } from "react";
import { Route, Routes, Navigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import { getUserMenuPermissions } from "../../core/data/redux/user/rolePermission/rolePermissionAction";
import { AppDispatch } from "../../core/data/redux/store";

const ALLRoutes: React.FC = () => {
  const { userMenuPermissions } = useSelector((state: any) => state.rolePermission);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!userMenuPermissions || Object.keys(userMenuPermissions).length === 0) {
      dispatch(getUserMenuPermissions());
    }
  }, [dispatch, userMenuPermissions]);

  // ✅ Filter only routes whose menuName matches backend keys
  const allowedPublicRoutes = useMemo(() => {
    if (!userMenuPermissions || Object.keys(userMenuPermissions).length === 0) return [];

    const backendKeys = Object.keys(userMenuPermissions?.menuPermissions || {}).map((k) => k.trim());

    return publicRoutes.filter((route) => {
      if (!route.menuName) return false;
      const routeKey = route.menuName.trim();
      return backendKeys.includes(routeKey);
    });
  }, [userMenuPermissions]);

  // ✅ Handle loading
  if (!userMenuPermissions || Object.keys(userMenuPermissions).length === 0) {
    return <div>Loading...</div>;
  }

  // ✅ Determine where to go when hitting "/"
  const defaultRedirectPath =
    allowedPublicRoutes.length > 0 ? allowedPublicRoutes[0].path : "/login";

  return (
    <Routes>
      {/* ✅ Public routes */}
      <Route element={<Feature />}>
        {/* Default redirect (when path = "/") */}
        <Route index element={<Navigate to={defaultRedirectPath} replace />} />

        {allowedPublicRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}

        {/* ❌ No match → 404 */}
        <Route path="*" element={<Navigate to="/error-404" replace />} />
      </Route>

      {/* ✅ Auth routes (like login, register, etc.) */}
      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
      </Route>
    </Routes>
  );
};

export default ALLRoutes;
